import { ReplaySubject } from 'rxjs'
import { EventEmitter, Injectable } from '@angular/core'

export interface Crumb {
  name: string
  segments?: any[]
}

@Injectable()
export class BreadcrumbsService {
  crumbs = new ReplaySubject<Crumb[]>(1)
}
